module.exports = __webpack_public_path__ + "img/jiangxin.a0ee21c1.png";